// extracted by mini-css-extract-plugin
module.exports = {"main":"ShopItemsProduct_main__t3vHQ","information":"ShopItemsProduct_information__X07W3"};